import { ContactListTab } from 'legacy/lut/components/widgets/public/partnerContacts/components/contactListTab/ContactListTab'
import { useSelector } from 'react-redux'

import { selectRouteParams } from 'core-components/sitebuilder/store/selectors/selectRouteParams'

import { COLUMNS, COLUMNS_PARTNER360, IGNORED_FIELDS } from './configs'
import { useAllContactsSource } from './hooks/useAllContactsSource'
import { IAllContactsTabProps } from './models'

export const AllContactsTab = (props: IAllContactsTabProps) => {
  const routeParams = useSelector(selectRouteParams)

  const isPartner360Page = routeParams.page === 'jbl-hpscoutso'
  const columns = isPartner360Page ? COLUMNS_PARTNER360 : COLUMNS

  return (
    <ContactListTab
      {...props}
      useSource={useAllContactsSource}
      columns={columns}
      ignoredFields={IGNORED_FIELDS}
      isPartner360Page={isPartner360Page}
    />
  )
}
